import requests from '../util';

const { request } = requests;

const fetchListAll = (
    pageNum,
    pageSize,
    requestType
) => {
  return request({
    url: `/api/v1/request/listAll?requestType=${requestType}`,
    method: 'get',
    params:{
        pageNum,
        pageSize,
        requestType
    }
  });
};



const listApi = {
    fetchListAll,
};

export default listApi;
